export default {
  pending: {},
  available: {},
  opening: {},
  closing: {},
  rowsOpeningClosing: [
    // GROUP 1
    [
      {
        id: 'payInVolume',
        columns: {},
      },
      {
        id: 'payInFee',
        columns: {},
      },
    ],
    // GROUP 2
    [
      {
        id: 'refundVolume',
        columns: {},
      },
      {
        id: 'refundFee',
        columns: {},
      },
    ],
    // GROUP 3
    [
      {
        id: 'chargebackVolume',
        columns: {},
      },
      {
        id: 'chargebackFee',
        columns: {},
      },
      {
        id: 'chargebackAdditionalFee',
        columns: {},
      },
    ],
    // GROUP 4
    [
      {
        id: 'otherServiceFees',
        columns: {},
      },
      {
        id: 'fundsTransfer',
        columns: {},
      },
      {
        id: 'transferFee',
        columns: {},
      },
      {
        id: 'currencyExchange',
        columns: {},
      },
      {
        id: 'settlement',
        columns: {},
      },
      {
        id: 'settlementFee',
        columns: {},
      },
      {
        id: 'balanceCorrection',
        columns: {},
      },
    ],
  ],
  accruedHoldbackVolume: {},
  netHoldbackVolume: {},
  rowsReversedHoldback: [
    [
      {
        id: 'holdbackVolume',
        columns: {},
      },
      {
        id: 'unblockedHoldbackVolume',
        columns: {},
      },
    ],
  ],
  fundsReserved: {},
};
